import {
  FormControl,
  FormControlLabel,
  FormLabel,
  RadioGroup,
  Typography,
} from "@material-ui/core";
import React from "react";
import { StyledRadio } from "../../../../../utils/designComponents/StyledRadio";

export default function OptionChainStrategyRadioButtons(props) {
  const hugCurrentPriceEnabled = props.hugCurrentPriceEnabled;
  const setHugCurrentPriceEnabled = props.setHugCurrentPriceEnabled;
  const dispatchHugCurrentPrice = props.dispatchHugCurrentPrice;
  const hugCurrentPrice = props.hugCurrentPrice;

  const otm1Enabled = props.otm1Enabled;
  const setOtm1Enabled = props.setOtm1Enabled;
  const otm1 = props.otm1;
  const dispatchOtm1 = props.dispatchOtm1;

  const itm1Enabled = props.itm1Enabled;
  const setItm1Enabled = props.setItm1Enabled;
  const itm1 = props.itm1;
  const dispatchItm1 = props.dispatchItm1;

  let value = "";

  if (hugCurrentPriceEnabled) {
    value = "hugCurrentPrice";
  } else if (otm1Enabled) {
    value = "otm1";
  } else if (itm1Enabled) {
    value = "itm1";
  }

 // console.log("value:" + value);

  const handleChange = (ev) => {
    console.log(ev.target.value);
    switch (ev.target.value) {
      case "otm1":
        setOtm1Enabled(true);
        setHugCurrentPriceEnabled(false);
        setItm1Enabled(false);
        dispatchOtm1({});
        break;
      case "itm1":
        console.log("setting itm1");
        setItm1Enabled(true);
        setOtm1Enabled(false);
        setHugCurrentPriceEnabled(false);
        dispatchItm1({});
        break;
      case "hugCurrentPrice":
        setHugCurrentPriceEnabled(true);
        setOtm1Enabled(false);
        setItm1Enabled(false);
        break;
    }
  };

  return (
    <>
      <FormControl component="fieldset">
        <FormLabel component="legend">
          <Typography style={{ fontSize: 15 }}>
            Option Chain Strategy
          </Typography>
        </FormLabel>
        <RadioGroup
          aria-label="Option Chain Strategy"
          name="Option Chain Strategy"
          value={value}
          onChange={handleChange}
        >
          <FormControlLabel
            value="hugCurrentPrice"
            control={<StyledRadio />}
            label={
              <Typography style={{ fontSize: 10 }}>Tightest Spread</Typography>
            }
          />
          <FormControlLabel
            value="otm1"
            control={<StyledRadio />}
            label={<Typography style={{ fontSize: 10 }}>OTM1</Typography>}
          />
          <FormControlLabel
            value="itm1"
            control={<StyledRadio />}
            label={<Typography style={{ fontSize: 10 }}>ITM1</Typography>}
          />
        </RadioGroup>
      </FormControl>
    </>
  );
}
